import CompanyNewModal from "company/new/App";
import { ButtonPrimary } from "components/Atoms/Button";
import Modal from "components/modal";
import ContactNewModal from "contact/new/App";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";

interface Props {
  onClose: () => void
  isOpen: boolean
}

const NewAddressBookModal = (props: Props) => {
  const [newCompanyState, setNewCompanyState] = React.useState<"artist" | "venue" | "promoter" | "company">(null);
  const [displayNewContact, setDisplayNewContact] = React.useState(false);
  return <>
    {newCompanyState && <CompanyNewModal
      onClose={() => setNewCompanyState(null)}
      onCreated={c => window.location.href = routes.company_Detail(c.companyId).absolute}
      defaults={{
        isArtist: newCompanyState === "artist",
        isVenue: newCompanyState === "venue",
        isPromoter: newCompanyState === "promoter"
      }}
    />}

    {displayNewContact && <ContactNewModal
      onClose={() => setDisplayNewContact(false)}
      onCreated={c => window.location.href = routes.contact_Detail(c.contactId).absolute}
    />}
    <Modal
      isOpen={props.isOpen && !newCompanyState}
      handleClose={props.onClose}
      displayHeader={false}
      gap="small"
    >
      {site.currentEnvironment.functionGroups.artist.enabled && (<div>
        <ButtonPrimary
          style={{ justifyContent: "flex-start" }}
          label={site.currentEnvironment.functionGroups.artist.newLabel}
          onClick={() => setNewCompanyState("artist")}
          fluid
        />
      </div>)}
      {site.currentEnvironment.functionGroups.venue.enabled && (<div>
        <ButtonPrimary
          style={{ justifyContent: "flex-start" }}
          label={site.currentEnvironment.functionGroups.venue.newLabel}
          onClick={() => setNewCompanyState("venue")}
          fluid
        />
      </div>)}
      {site.currentEnvironment.functionGroups.promoter.enabled && (<div>
        <ButtonPrimary
          style={{ justifyContent: "flex-start" }}
          label={site.currentEnvironment.functionGroups.promoter.newLabel}
          onClick={() => setNewCompanyState("promoter")}
          fluid
        />
      </div>)}
      {site.currentEnvironment.company.enabled && (<div>
        <ButtonPrimary
          style={{ justifyContent: "flex-start" }}
          label={site.currentEnvironment.company.newLabel}
          onClick={() => setNewCompanyState("company")}
          fluid
        />
      </div>)}
      {site.currentEnvironment.contact.enabled && (<div>
        <ButtonPrimary
          style={{ justifyContent: "flex-start" }}
          label={site.currentEnvironment.contact.newLabel}
          onClick={() => setDisplayNewContact(true)}
          fluid
        />
      </div>)}
    </Modal>
  </>;
};

export default NewAddressBookModal;